module.exports = __webpack_public_path__ + "static/media/STX.874f4488.svg";